import React, { useRef, useEffect } from 'react';
import { NavigationContainer, DarkTheme, useIsFocused } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from '@expo/vector-icons';
import AppLoading from 'expo-app-loading';
import { useFonts } from 'expo-font';
import { Animated } from 'react-native';

// Import dei componenti di navigazione
import HomeScreen from './src/components/HomeScreen';
import NewsScreen from './src/components/NewsScreen';
import GalleryScreen from './src/components/GalleryScreen';
import EventsScreen from './src/components/EventsScreen';
import AccountScreen from './src/components/AccountScreen';

// Tema dark personalizzato
const MyDarkTheme = {
  ...DarkTheme,
  colors: {
    primary: "#bb86fc",
    background: "#121212",
    card: "#1e1e1e",
    text: "#ffffff",
    border: "#121212",
    notification: "#03dac6",
  },
};

const Tab = createBottomTabNavigator();

// Wrapper per applicare il fade in/out quando lo schermo è in focus
const AnimatedScreen = ({ children }) => {
  const opacity = useRef(new Animated.Value(0)).current;
  const isFocused = useIsFocused();

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: isFocused ? 1 : 0,
      duration: 300,
      useNativeDriver: true,
    }).start();
  }, [isFocused, opacity]);

  return (
    <Animated.View style={{ flex: 1, opacity }}>
      {children}
    </Animated.View>
  );
};

// Definizione delle schermate
const screens = [
  { name: "Home", component: HomeScreen },
  { name: "Notizie", component: NewsScreen },
  { name: "Archivio", component: GalleryScreen },
  { name: "Eventi", component: EventsScreen },
  { name: "Account", component: AccountScreen },
];

// Mappa delle icone per ogni scheda
const icons = {
  Home: "home",
  Notizie: "newspaper",
  Archivio: "images",
  Eventi: "calendar",
  Account: "person",
};



export default function App() {
  const [fontsLoaded] = useFonts({
    CustomFont: require('./assets/font.ttf'),
  });

  useEffect(() => {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Assicurati che il file 'firebase-messaging-sw.js' sia servito nella posizione corretta
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log('Service Worker registrato con successo:', registration);
        })
        .catch(error => {
          console.error('Errore nella registrazione del Service Worker:', error);
        });
    });
  }
}, []);


  if (!fontsLoaded) return <AppLoading />;

  return (
    <NavigationContainer theme={MyDarkTheme}>
      <Tab.Navigator
        screenOptions={({ route }) => ({
          headerShown: false,
          tabBarShowLabel: false,
          tabBarIcon: ({ focused, color, size }) => {
            const icon = icons[route.name];
            const iconName = focused ? icon : `${icon}-outline`;
            // Aumenta leggermente la dimensione dell'icona per enfatizzare la navbar
            const iconSize = focused ? size + 4 : size + 2;
            return <Ionicons name={iconName} size={iconSize} color={color} />;
          },
          tabBarStyle: {
            backgroundColor: "#1e1e1e",
            borderTopColor: "#121212",
            paddingBottom: 12,  // Maggiore padding inferiore
            paddingTop: 10,     // Maggiore padding superiore
            height: 80,         // Altezza aumentata per rendere la navbar più "ampia"
          },
          tabBarActiveTintColor: "#bb86fc",
          tabBarInactiveTintColor: "gray",
        })}
      >
        {screens.map(({ name, component: ScreenComponent }) => (
          <Tab.Screen key={name} name={name}>
            {props => (
              <AnimatedScreen>
                <ScreenComponent {...props} />
              </AnimatedScreen>
            )}
          </Tab.Screen>
        ))}
      </Tab.Navigator>
    </NavigationContainer>
  );
}
